import type ProgressBarPropsType from "@/lib/types/visualizations/metrics/ProgressBar.type";

export default function ProgressBar({
  currentStep,
  totalSteps,
  className,
  height = 8,
  trackColor = "var(--color-background-elevated)",
  progressColor = "var(--color-background-brand)",
  rounded = true,
}: ProgressBarPropsType) {
  const normalizedTotal = totalSteps > 0 ? totalSteps : 0;
  const clampedCurrent = Math.min(Math.max(currentStep, 0), normalizedTotal);
  const progressPercentage =
    normalizedTotal === 0 ? 0 : (clampedCurrent / normalizedTotal) * 100;
  const edgeRadius = rounded ? 9999 : 0;

  return (
    <div
      className={className}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={normalizedTotal}
      aria-valuenow={clampedCurrent}
      style={{
        width: "100%",
        height,
        backgroundColor: trackColor,
        borderRadius: edgeRadius,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          width: `${progressPercentage}%`,
          height: "100%",
          backgroundColor: progressColor,
          borderRadius: edgeRadius,
          transition: "width 180ms ease-in-out",
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
        }}
      />
    </div>
  );
}
